
import authService from "../services/auth";
import { clearAuthStorage, normalizeAuthResponse, persistAuthState } from "../utils/authStorage";
 
async function signIn(dispatch, data) {

    dispatch({type : 'loginPending'});

    let [response, error] = await authService.signIn(data);

    if (error !== null) {
            return {
                error: true,
                status: error.message === "Renew Password" ? 403 : 0,
                message: error.message
            };

    }

    const { token, refreshToken, user, company, permissions } = normalizeAuthResponse(response);

    dispatch({type : 'loginSuccess', payload : {refreshToken, token, user}});

    persistAuthState({ token, refreshToken, user, company, permissions });

    return { ...response, token, refresh_token: refreshToken, user, company, permissions };
}

function signOut(dispatch) {
    clearAuthStorage();
    dispatch({type : 'loginOut'});
}

export default { signIn, signOut }